export const formatLogonId = (logonId: string) => logonId.toLowerCase().trim();
